import { Auth } from "shared/@auth/Auth";
import { useQuery, useMutation, useQueryClient } from "react-query";
import toast from "react-hot-toast";
import createNotification from "shared/@utils/createNotification";

export const useGroups = () => {
  const { makeAuthedRequest } = Auth.useContainer();

  const { data, isError, isLoading, refetch } = useQuery(["groups"], () =>
    makeAuthedRequest(`/dreamstream/organizations`, {
      method: "GET",
    }).then(async (res) => {
      if (res.ok) {
        return res.json();
      } else {
        const body = await res.json();
        throw new Error(body.message);
      }
    })
  );

  return {
    data,
    refetch,
    isError,
    isLoading,
  };
};

export function useAddGroup() {
  const { makeAuthedRequest } = Auth.useContainer();
  const queryClient = useQueryClient();

  const addGroup = useMutation((group) =>
    makeAuthedRequest(`/dreamstream/organization/create/group`, {
      method: "POST",
      body: JSON.stringify(group),
    }).then(async (res) => {
      if (res.ok) {
        return res;
      } else {
        const body = await res.json();
        createNotification({
          type: "danger",
          title: "Error",
          message: body.error,
          autoDismiss: true,
        });
        throw new Error(body.error);
      }
    })
  );

  const { mutate } = useMutation(addGroup, {
    onSuccess: () => {
      queryClient.invalidateQueries("plugins");
      createNotification({
        type: "success",
        title: "Saved",
        message: "A new group was saved successfully.",
        autoDismiss: true,
      });
    },
    onError: (err) => {
      console.error(err);
      toast.error("Something went wrong!");
    },
  });

  return { addGroup, mutate };
}

// export function useAddGroup() {
//   const { makeAuthedRequest } = Auth.useContainer();
//   const queryClient = useQueryClient();

//   const addGroup = async (group) => {
//     return makeAuthedRequest(`/dreamstream/organization/create/group`, {
//       method: "POST",
//       body: JSON.stringify(group),
//     }).then(async (res) => {
//       if (res.ok) {
//         return res;
//       } else {
//         const body = await res.json();
//         throw new Error(body.error);
//       }
//     });
//   };

//   const { mutate } = useMutation(addGroup, {
//     onSuccess: () => {
//       queryClient.invalidateQueries("groups");
//       createNotification({
//         type: "success",
//         title: "Saved",
//         message: "A new group was saved successfully.",
//         autoDismiss: true,
//       });
//     },
//     onError: (err) => {
//       console.error(err);
//       toast.error("Something went wrong!");
//     },
//   });

//   return mutate;
// }

//export const Groups = createContainer(useGroups);
